import React from "react";
import { InfoIcon } from "../baseComponents/Icons";
import styles from "./InfoText.module.scss";

export const InfoText = ({ children }: { children: any }) => {
  return (
    <div className={styles.Info}>
      <InfoIcon />
      <p className={styles.InfoText}>{children}</p>
    </div>
  );
};
